'use client';

import { createEntityVerificationHighlightPlugin } from '@/components/tiptap/shared/entity-verification-highlight/create-plugin';
import { Extension } from '@tiptap/react';

export interface EntityVerificationHighlightOptions {
  /**
   * Whether the extension is enabled
   */
  enabled: boolean;
}

/**
 * markdown-native twin of the entity-verification highlight. Standalone
 * `Extension.create` (no `.extend()` of the vMarkdown one) wrapping the shared
 * decoration plugin in `tiptap/shared/entity-verification-highlight`. The
 * verified/flagged highlighting and its hover tooltip are wired in
 * `note-editor-container` via `useEntityVerificationSync` +
 * `EntityVerificationTooltipProvider`, at parity with vMarkdown.
 */
export const EntityVerificationHighlight =
  Extension.create<EntityVerificationHighlightOptions>({
    name: 'entityVerificationHighlight',

    addOptions() {
      return {
        enabled: true,
      };
    },

    addProseMirrorPlugins() {
      return [createEntityVerificationHighlightPlugin({ enabled: this.options.enabled })];
    },
  });
